import { render, staticRenderFns } from "./trainingType.vue?vue&type=template&id=7c4a54ef&scoped=true"
import script from "./trainingType.vue?vue&type=script&lang=js"
export * from "./trainingType.vue?vue&type=script&lang=js"
import style0 from "./trainingType.vue?vue&type=style&index=0&id=7c4a54ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a54ef",
  null
  
)

export default component.exports